export default "__VITE_ASSET__9c14817a__"